import React, {
  createContext,
  useReducer,
  useContext,
  useEffect,
  Context,
  Dispatch,
} from 'react';
import {
  CommunityOptInReducer,
  CommunityOptInState,
  CommunityOptInAction,
  CommunityOptInStateType,
} from './useCommunityOptInReducer';
import { Routes, useUserInfo } from '@xolv-mybrightlink/common';
import { UserProfileContext } from '../../profile';
import { useNavigate } from 'react-router-dom';

interface Props {
  children?: React.ReactNode;
}

export const CommunityOptInContext = createContext<unknown>({});

export const CommunityOptInProvider: React.FC<Props> = ({ children }) => {
  const user = useUserInfo();
  const [profile] = useContext(UserProfileContext);
  const navigate = useNavigate();

  const isOptedIn = user && user.community_opt_in;

  const hasWithdrawnBefore =
    user != null &&
    !user.community_opt_in &&
    user.community_opt_out_date != null;

  const initialCommunityOptInState = {
    currentState: isOptedIn
      ? CommunityOptInStateType.ACCEPTED
      : CommunityOptInStateType.INITIAL,
    hasWithdrawnBefore: hasWithdrawnBefore,
  };

  const [state, dispatch] = useReducer(
    CommunityOptInReducer,
    initialCommunityOptInState,
  );

  useEffect(() => {
    if (
      state.currentState === CommunityOptInStateType.ACCEPTED &&
      profile &&
      !user.profile_setup
    ) {
      navigate(Routes.profile.basic, {
        state: { source: 'community' },
        replace: true,
      });
    }
  }, [state.currentState, user, profile, navigate]);

  return (
    <CommunityOptInContext.Provider value={[state, dispatch]}>
      {children}
    </CommunityOptInContext.Provider>
  );
};

export const useCommunityOptIn = () =>
  useContext<[CommunityOptInState, React.Dispatch<CommunityOptInAction>]>(
    CommunityOptInContext as Context<
      [CommunityOptInState, Dispatch<CommunityOptInAction>]
    >,
  );
